"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Context = /** @class */ (function () {
    function Context(opts) {
        this._id = opts ? opts.id : undefined;
        this._origValue = opts ? opts.value : undefined;
        this._value = opts ? opts.value : undefined;
        this._factory = opts ? opts.factory : undefined;
    }
    Object.defineProperty(Context.prototype, "value", {
        get: function () {
            if (!this._value) {
                if (!this._origValue && this._factory) {
                    this._origValue = this._factory();
                }
                this._value = this._origValue;
            }
            return this._value;
        },
        set: function (value) {
            this.setValue(value);
        },
        enumerable: true,
        configurable: true
    });
    Context.prototype.setValue = function (value) {
        this._value = value;
    };
    Context.prototype.clearValue = function () {
        this._value = undefined;
    };
    return Context;
}());
exports.Context = Context;
